import { AuthType, AuthTypeEnum, BaseAuthenticationMethod } from './base-authentication-method';

export class Digid extends BaseAuthenticationMethod {
    type = 'digid';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
